import { dataFetcher } from 'core/services/requestHandler';   

const saveCoupon = async (data = {}, config = {}) => {
  return dataFetcher('coupons/saveCoupon', data, {method: 'POST', ...config});
};

const getCoupons = async (data = {}, config = {}) => {
  return dataFetcher('coupons/getCoupons', data, {...config});
};

const getCouponDetails = async (data = {}, config = {}) => {
  return dataFetcher('coupons/getCouponDetails', data, {...config});
};

const deleteCoupon = async (data = {}, config = {}) => {
  return dataFetcher('coupons/deleteCoupon', data, {...config});
};

export { saveCoupon, getCoupons, getCouponDetails, deleteCoupon };
